import { z } from 'zod';

import { TextItem } from './common';

export const ReasonsForLiving = z.array(TextItem).default([]);
export type ReasonsForLiving = z.infer<typeof ReasonsForLiving>;
